import React from "react";

const Settings = () => {
  return (
    <div>
      <div>Settings</div>
    </div>
  );
};

export default Settings;
